import styled from 'styled-components';
import C from '@assets/themes/colors';
interface IRootProps {
  selected?:boolean;
}

export const Root = styled.div`
  width: auto;
  height: 34px;
  padding: 7px 0px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

export const Label = styled.label`
  height: 19px;
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  color: #ffffff;
  display: table-cell;
  padding-right:15px;
  white-space: nowrap;
  margin: 0px 0px 7px 0px;
`

export const Btn = styled.div`
  padding: 4px 8px 2px 8px;
  display: flex;
  flex-direction: row;
  border: 1px solid #ffffff;
  border-radius:4px;
  margin-left:0px;
  cursor: pointer;
  height: 28px;
  background-color: ${(props: IRootProps) => props.selected? 'rgba(255, 255, 255, 0.2)' : ''};
`

export const Menu = styled.div`
  width: 256px;
  height: auto;
  display: none;
  position: absolute;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 51;
  margin-left: -105px;
  margin-top: 10px; 
  top: 43px;
`;

export const Option = styled.div`
  width: auto;
  height: 20px;
  flex-grow: 0;
  background-color: ${(props: IRootProps) => props.selected? 'rgba(18, 36, 66, 0.05)':'#ffffff'};
  padding: ${(props: IRootProps) => props.selected? '14px 16px':'7.5px 16px'};
  font-size: 16px;
  font-weight: 500;
  color: #272727;
  cursor:pointer;
  &:hover{
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const Extra = styled.span`
  font-weight: 400;
`;

